const MAP_BOUNDS_KEYS = [
    'neLat', 'neLong', 'swLat', 'swLong', 'zoom'
];

export const isMapBoundsChange = (params, prevParams) =>
    MAP_BOUNDS_KEYS.reduce((acc, key) => {
        return acc || params[key] !== prevParams[key]
    }, false);

export const isDestinationChange = (params, prevParams) => {
    return params.q !== prevParams.q;
};

export const needAdsRefresh = (params, prevParams) => {
    if (!params || !prevParams) {
        return false;
    }

    return !(
        isMapBoundsChange(params, prevParams) ||
        isDestinationChange(params, prevParams)
    );
};
